module.exports = __webpack_public_path__ + "img/position-evn.1719d93c.png";